import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';
import BudgetCategoriesSelector from '../UserFinances/BudgetCategoriesSelector';

function AddBudgetMonthlyElement({type}) {

    const appState = useContext(StateContext)

    const [sum, setSum] = useState(0);
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState();
    const [date, setDate] = useState("");
    const [month, setMonth] = useState(10);
    const [year, setYear] = useState(2020);

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {

        if (date) {

            const dateBudget = new Date(date);
            const year = dateBudget.getFullYear();
            const month = dateBudget.getMonth()+1
            setYear(year);
            setMonth(month)

        }

    }, [date])

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const budgetRef = firestore.collection("users").doc(appState.userId).collection("budget-monthly");
            const dateBudget = new Date(date).toISOString();
            const data = {
                sum: +sum,
                type,
                description,
                category,
                month, 
                year,
                date: dateBudget
            }
            budgetRef.add(data);
            setMessage("Lagt til!")
        } catch (error) {
            setMessage("Kunne ikke legge til")
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Beskrivelse</label>
            <input className="form-control mb-2" value={description} onChange={e => setDescription(e.target.value)} />

            <label>Sum</label>
            <input type="number" className="form-control mb-2" value={sum} onChange={e => setSum(e.target.value)} />

            <label>Dato</label>
            <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} />

            <label>Kategori</label>
            <BudgetCategoriesSelector type={type} category={category} setCategory={setCategory} />

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}
            <button className="btn btn-success btn-block">Lagre budsjettelement</button>
        </form>
    )

}
export default AddBudgetMonthlyElement